export { default } from "./InfoAlert";
